const emailRegex = /^\w+([.+-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/

export function isEmail(email: string): boolean {
  return emailRegex.test(email)
}

/**
 * Pass in a predicate function to operate on an array of data and check
 * if each item passes the predicate. v-combobox as a primary use case of
 * this but could be other hand rolled or vuetify components where this fits
 * @param predicate function should take in an
 * @returns boolean
 *
 * @example - vanilla TypeScript
 * validateAll(isEmail)(['tester@testing.com'])
 * @returns true
 *
 * @example - v-combobox
 * <v-combobox :rules="[validateAll(isEmail)]"></v-combobox>
 */
export function validateAll<T>(predicate: (t: T) => boolean): (data: Array<T>) => boolean {
  return function (data: Array<T>): boolean {
    return data.every(predicate)
  }
}
